module.exports = __webpack_public_path__ + "static/media/customFieldUpgrade.fe8d9b01.png";